import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-customers-dialog',
  templateUrl: './customers-dialog.component.html',
  styleUrls: ['./customers-dialog.component.scss']
})
export class CustomersDialogComponent implements OnInit {

  customers: any;
  gridType: any = 'branch';
  matchedHeaders: any[];
  headers: string[];
  LoaderComponent: any;

  constructor(
    public dialogRef: MatDialogRef<CustomersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public service: WebRequestService,
  ) {
    this.customers = data;
    this.prepareHeaders();
   }

   prepareHeaders() {
     this.matchedHeaders = [
      { title: 'Sno', value: 'SNO' },
      { title: 'Profile Id', value: 'profileID' },
      { title: 'Arrival', value: 'arrivedOn' },
      { title: 'Departure', value: 'departingOn' },
      { title: 'Firstname', value: 'firstName' },
      { title: 'Lastname', value: 'lastName' },
      { title: 'City', value: 'city' },
      { title: 'Country', value: 'country' },
      {title:'Number', value: 'primarynumber'},
      { title: 'Update', value: 'customerUpdate' }
     ];

     this.headers = ['SNO', 'profileID', 'arrivedOn', 'departingOn', 'firstName', 'lastName', 'primarynumber', 'city', 'country', 'customerUpdate'];
   }

   reloadCustomers(event) {
      if (event) {
        this.customers = [];
        this.LoaderComponent = LoaderComponent;
        this.service.getCustomersInLastWeek().then((res) => {
          if (res['statusCode'] === 200) {
            this.LoaderComponent = '';
            const result = res['result'];
            if(result.length > 0) {
              this.customers = res['result'];
            } else {
              this.dialogRef.close(true);
            }
          } else {
            this.dialogRef.close(true);
          }
        })
      }
   }

  ngOnInit(): void {
  }

}
